export enum OrderProductsTestIds {
  SECTION_ERROR_ICON = 'order-products-section-error-icon',
  OBJECT_TAB_ERROR_ICON = 'order-products-object-tab-error-icon',
  VALIDATION_ICON = 'order-products-validation-icon',
  VALIDATION_TOOLTIP = 'order-products-validation-tooltip',
  GRID_ITEM = 'order-product-grid-item',
  GRID_LINE = 'order-product-grid-line',
  GRID_STOCK_VALUE = 'order-product-grid-stock-value',
  PRICE = 'order-products-price',
  PRICE_ORIGINAL = 'order-products-price-original',
  PRICE_DISCOUNTED = 'order-products-price-discounted',
  PRICE_TOOLTIP = 'products-price-tooltip',
  QUANTITY = 'order-products-quantity',
  TOTAL = 'order-products-total',
  COLOR_CODE = 'order-products-color-code',
  PRODUCT_NAME = 'order-products-product-name',
  PRODUCT_CODE = 'order-products-product-code',
  DELIVERY_WINDOW = 'order-products-delivery-window',
  COLOR_SEARCH = 'order-products-color-search',
  DELIVERY_WINDOW_SEARCH = 'order-products-delivery-window-search',
  DELETE_ICON = 'order-products-delete-icon',
  SEARCH_FIELD = 'order-products-search-field',
  CONDITION_CHIP = 'order-products-condition-chip',
  CONDITION_CHIP_MENU = 'order-products-condition-chip-menu',
  GROUP_HEADER = 'order-products-group-header',
  GROUP_HEADER_TOGGLE = 'order-products-group-header-toggle',
  GROUP_HEADER_BULK_TOGGLE = 'order-products-group-header-bulk-toggle',
  MASS_ACTIONS_BAR = 'order-products-mass-actions-bar',
  MASS_ACTIONS_SUMMARY = 'order-products-mass-actions-summary',
  EDIT_SUGGESTED_ORDER_BUTTON = 'order-products-edit-suggested-order-button',
}

export enum OrderProductsViewTestIds {
  TOGGLE_BUTTON = 'order-products-view-toggle-button',
  PANEL = 'order-products-view-panel',
  GROUP_BY_TRIGGER = 'order-products-view-group-by-trigger',
  SUBGROUP_BY_TRIGGER = 'order-products-view-subgroup-by-trigger',
  SORT_BY_TRIGGER = 'order-products-view-sort-by-trigger',
  HIDE_ORDER_TOTALS_SWITCH = 'order-products-view-hide-order-totals-switch',
  HIDE_SECTIONS_BUTTON = 'order-products-view-hide-sections-button',
  EXPAND_SECTIONS_BUTTON = 'order-products-view-expand-sections-button',
  RESTORE_BUTTON = 'order-products-view-restore-button',
  APPLY_BUTTON = 'order-products-view-apply-button',
}

export enum AddOrderProductTestIds {
  ADD_CODE_BUTTON = 'add-order-product-add-code-button',
  SUBMIT_BUTTON = 'add-order-product-button',
  PRODUCT_CODE_INPUT = 'add-order-product-code-input',
  COLOR_AUTOCOMPLETE = 'add-order-product-color-autocomplete',
  COLOR_SEARCH = 'add-order-product-color-search',
  DELIVERY_WINDOW = 'add-order-product-delivery-window',
  CLEAN_BUTTON = 'add-order-product-clean-button',
  PRODUCT_GRID = 'add-order-product-grid',
  MODE_MENU_BUTTON = 'add-order-product-mode-menu-button',
  MODE_MENU_TITLE = 'add-order-product-mode-menu-title',
  MODE_MENU_RACHEL = 'add-order-product-mode-menu-rachel',
  MODE_MENU_ITEM_PRODUCT = 'add-order-product-mode-menu-item-product',
  MODE_MENU_ITEM_COLOR = 'add-order-product-mode-menu-item-color',
  MODE_MENU_ITEM_SKU = 'add-order-product-mode-menu-item-sku',
}
